import Translations from "translations/types";

const REVERSE_SEARCH_PAGE_EXISTING_KEY = "reverse_searches_existing" as const;

const REVERSE_SEARCH_EXISTING_STEPS = {
  ADD_NEW_SEARCH: "add_new_search",
  EXISTING_SEARCH: "existing_search",
} as const;

export const REVERSE_SEARCH_PAGE_EXISTING = {
  doneLabel: (t: Translations) => t.tours.reverseSearch.doneButton,
  key: REVERSE_SEARCH_PAGE_EXISTING_KEY,
  nextLabel: (t: Translations) => t.tours.reverseSearch.nextButton,
  prevLabel: (t: Translations) => t.tours.reverseSearch.backButton,
  scrollTo: "tooltip",
  steps: {
    [REVERSE_SEARCH_EXISTING_STEPS.ADD_NEW_SEARCH]: {
      intro: (t: Translations) => t.tours.reverseSearch.stepG.intro,
      key: REVERSE_SEARCH_EXISTING_STEPS.ADD_NEW_SEARCH,
      position: "top",
      step: 2,
      title: (t: Translations) => t.tours.reverseSearch.stepG.title,
    },
    [REVERSE_SEARCH_EXISTING_STEPS.EXISTING_SEARCH]: {
      intro: (t: Translations) => t.tours.reverseSearch.stepE.introCapacityMode,
      key: REVERSE_SEARCH_EXISTING_STEPS.EXISTING_SEARCH,
      position: "left",
      step: 1,
      title: (t: Translations) => t.tours.reverseSearch.stepF.title,
    },
  },
} as const;
